import { SoapTemplate } from "src/app/backend/models/soap-template";
import { tryParseJson } from "src/app/support/json";

export type SoapTemplateSection = {
  config?: { tabs?: Array<{ items?: unknown[] }> };
};

export function soapTemplateIsEmpty(template: SoapTemplate): boolean {
  const sections = parseObjectValues<
    SoapTemplateSection | SoapTemplateSection[]
  >(template?.detail).flatMap((value) =>
    Array.isArray(value) ? value : value ? [value] : []
  );

  return !soapSectionsHaveContent(sections);
}

export function soapSectionsHaveContent(
  sections: SoapTemplateSection[]
): boolean {
  return sections
    .flatMap((section) => section?.config?.tabs ?? [])
    .some((tab) => (tab?.items?.length ?? 0) > 0);
}

function parseObjectValues<T = unknown>(
  source: Record<string, unknown> | undefined
): Array<T | undefined> {
  return Object.values(source ?? {}).map((value) =>
    typeof value === "string" ? tryParseJson<T>(value, undefined) : (value as T)
  );
}
